import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { BottomNav } from './BottomNav';
import { DesktopSidebar } from './DesktopSidebar';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_ai-persona-connect/artifacts/d3pkba7d_copy_8D43DC47-40F7-432E-B350-F206250169DA.png';

export function Layout({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  const isChatPage = location.pathname.startsWith('/chat/');
  const isAuthPage = location.pathname === '/login' || location.pathname === '/register';
  const isOnboarding = location.pathname === '/onboarding';
  const isWelcome = location.pathname === '/welcome';
  // When logged-out user lands on "/", they see the Welcome page — strip chrome too
  const isRootWelcome = location.pathname === '/' && !user;
  const hideChrome = isChatPage || isAuthPage || isOnboarding || isWelcome || isRootWelcome;

  return (
    <div className="min-h-screen bg-[#050505]">
      {/* Desktop sidebar (≥lg only). Hidden for chrome-less pages so they go full-bleed. */}
      {!hideChrome && <DesktopSidebar />}

      {/* Mobile-only sticky header — desktop uses the sidebar instead */}
      {!hideChrome && (
        <header
          className="lg:hidden sticky top-0 z-40 border-b border-white/[0.04] bottom-nav-glass"
          style={{ paddingTop: 'env(safe-area-inset-top)' }}
        >
          <div className="flex items-center justify-between h-12 px-4">
            <div className="w-8" />
            <Link to="/" className="flex items-center gap-2" data-testid="logo-link">
              <img src={LOGO_URL} alt="Animus" className="w-7 h-7 object-contain" />
              <span className="font-bold text-base tracking-tight text-white font-['Unbounded']">Animus</span>
            </Link>
            <div className="w-8" />
          </div>
        </header>
      )}

      {/* Main content area — pushes right of sidebar on desktop */}
      <main className={hideChrome ? '' : 'pb-20 lg:pb-0 lg:pl-60 xl:pl-64'}>
        {children}
      </main>

      {/* Bottom Navigation — mobile only */}
      {!hideChrome && <BottomNav />}
    </div>
  );
}
